import { Application } from "@hotwired/stimulus";

// Stimulus アプリケーションのシングルトン。
// コントローラは ViewComponent の sidecar (app/components/**/component.ts) や
// app/javascript/controllers/ から application.register で登録する。
const application = Application.start();
application.debug = false;

declare global {
  interface Window {
    Stimulus: Application;
  }
}
window.Stimulus = application;

export { application };
